export const environment = {
  production: false,
    /** Enable console.log or not. */
    enableConsole: false,
  apiRootUrl: 'https://B2B-webapi.dynamictire.com/',
  IAMUrl : 'https://B2B-idp.dynamictire.com/'
};
